export default "__VITE_ASSET__b54bb87e__"